import React from 'react';
import { whyItMatters } from '../mock';
import { ShieldAlert, LayoutGrid, FileSearch, Crown } from 'lucide-react';

const Icons = [ShieldAlert, LayoutGrid, FileSearch, Crown];

export default function WhyItMatters() {
  return (
    <section id="why" className="relative bg-[#0B1F2D] text-[#FAFAF5] overflow-hidden">
      <div className="absolute inset-0 grain opacity-40" />
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#1B6F5E]/15 blur-3xl" />

      <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div className="text-[11.5px] tracking-[0.16em] uppercase text-[#7BC2B0] font-medium">
              Why it matters
            </div>
            <h2 className="mt-3 font-display text-[40px] lg:text-[56px] leading-[1.02]">
              From voluntary
              <br />
              to <span className="italic text-[#7BC2B0]">enforceable.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-3">
            <p className="text-[16.5px] leading-[1.6] text-[#FAFAF5]/70 max-w-[640px]">
              ESG and climate disclosures are moving from voluntary to enforceable. Misstatements, omissions, and
              greenwashing can trigger investigations, fines, and reputational damage. ESGine® helps you identify and
              address compliance gaps before they become findings.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {whyItMatters.map((c, i) => {
            const Ico = Icons[i];
            return (
              <div
                key={c.title}
                className="rounded-2xl border border-white/10 bg-white/[0.03] p-7 transition-colors duration-300 hover:border-[#7BC2B0]/40 hover:bg-white/[0.05]"
              >
                <div className="w-10 h-10 rounded-lg bg-[#7BC2B0]/15 text-[#7BC2B0] flex items-center justify-center mb-5">
                  <Ico className="w-4.5 h-4.5" />
                </div>
                <div className="font-display text-[20px] leading-[1.18]">{c.title}</div>
                <p className="mt-3 text-[13.5px] leading-[1.6] text-[#FAFAF5]/65">{c.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
